import React from 'react';
import { Icon } from 'semantic-ui-react';
import { deleteLocationAC } from '../../action-creators';
import EditItemDialog from '../dialogs/edit-item-dialog';
import LocationForm from '../forms/location-form';
import confirmDialog from '../confirm-dialog';
import { CardAttr } from '../widgets/card-attr';
import styled from 'styled-components';
import { colors } from '../../themes';

const Container = styled.div`
  padding: 1em;
`;
const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function LocationCard(props: any) {
  return (
    <Container>
      <Header>
        <h3>{props.name}</h3>
        <Actions>
          <EditItemDialog form={LocationForm} {...props} />
          <Icon
            name="remove circle"
            onClick={() => confirmDialog(() => props.dispatch(deleteLocationAC(props._id)))}
            // color="red"
            size="large"
          />
        </Actions>
      </Header>
      <Content>
        <CardAttr title="Street">
          {props.route} {props.streetNumber}
        </CardAttr>
        <CardAttr title="City">{props.locality}</CardAttr>
        <CardAttr title="Country">{props.country}</CardAttr>
        <CardAttr title="gps">{props.gps && props.gps.coordinates ? props.gps.coordinates.join(',') : ''}</CardAttr>
      </Content>
    </Container>
  );
}
